import type { NavLinkItem } from 'Components/Layout/DrawerMenu/types'
import BasicLayout from 'Components/Layout/Templates/BasicLayout'
import CodespaceRoot from 'Services/ControlDataManagement/Features/Codespace'
import RefundCodeRoot from 'Services/ControlDataManagement/Features/RefundCode'
import SchoolRoot from 'Services/ControlDataManagement/Features/School'
import SchoolCalendarRoot from 'Services/ControlDataManagement/Features/SchoolCalendar'
import ZoneRoot from 'Services/ControlDataManagement/Features/Zone'
import {
  CONTROL_DATA_MANAGEMENT_ROOT_URL,
  IS_HSL_SERVICE_ENVIRONMENT,
  LOGIN_PAGE_PATH
} from 'Util/constants'
import ProtectedRoute from 'Util/ProtectedRoute'
import CodeIcon from '@mui/icons-material/Code'
import PaidIcon from '@mui/icons-material/Paid'
import SchoolIcon from '@mui/icons-material/School'
import WebhookIcon from '@mui/icons-material/Webhook'
import { Navigate, Route, Routes } from 'react-router-dom'
import { t } from 'ttag'

function ControlDataManagement() {
  const defaultMenuBarNavLinks: NavLinkItem[] = [
    {
      title: t`Zones`,
      link: `${CONTROL_DATA_MANAGEMENT_ROOT_URL}/zones`,
      icon: <WebhookIcon fontSize="small" />
    },
    {
      title: t`Codespaces`,
      link: `${CONTROL_DATA_MANAGEMENT_ROOT_URL}/codespaces`,
      icon: <CodeIcon fontSize="small" />
    },
    {
      title: t`Schools`,
      link: '/control-data-management/school-management',
      icon: <SchoolIcon fontSize="small" />
    }
  ]

  const hslMenuBarNavLinks: NavLinkItem[] = [
    {
      title: t`Zones`,
      link: `${CONTROL_DATA_MANAGEMENT_ROOT_URL}/zones`,
      icon: <WebhookIcon fontSize="small" />
    },
    {
      title: t`Refund codes`,
      link: `${CONTROL_DATA_MANAGEMENT_ROOT_URL}/refund-codes`,
      icon: <PaidIcon fontSize="small" />
    },
    {
      title: t`Codespaces`,
      link: `${CONTROL_DATA_MANAGEMENT_ROOT_URL}/codespaces`,
      icon: <CodeIcon fontSize="small" />
    }
  ]

  const menuBarNavLinks = IS_HSL_SERVICE_ENVIRONMENT ? hslMenuBarNavLinks : defaultMenuBarNavLinks

  return (
    <Routes>
      <Route element={<BasicLayout menuBarNavLinks={menuBarNavLinks} />} path="/">
        <Route index element={<Navigate to="zones/" />} />
        <Route path="/zones/*" element={<ZoneRoot />} />
        <Route
          element={
            <ProtectedRoute
              isAuthenticated={true}
              isAllowed={IS_HSL_SERVICE_ENVIRONMENT}
              authenticationPath={LOGIN_PAGE_PATH}
              restrictedPath={'/'}
            />
          }
        >
          <Route path="/refund-codes/*" element={<RefundCodeRoot />} />
        </Route>
        <Route path="/codespaces/*" element={<CodespaceRoot />} />
        <Route
          path="/school-management/*"
          element={
            <Routes>
              <Route index element={<Navigate to="schools" />} />
              <Route path="/schools/*" element={<SchoolRoot />} />
              <Route path="/school-calendars/*" element={<SchoolCalendarRoot />} />
            </Routes>
          }
        />
      </Route>
    </Routes>
  )
}

export default ControlDataManagement
